import React from "react";
import AboutBanner from "./AboutBanner";
import AboutSection1 from "./AboutSection1";
import AboutSection2 from "./AboutSection2";

const About = () => {
  return (
    <div>
      <AboutBanner></AboutBanner>
      <AboutSection1></AboutSection1>
      <AboutSection2></AboutSection2>
    </div>
  );
};

export default About;
